// Shared `only:` / `reset:` prop manifests for the v2
// notifications surface. Every callsite that partial-
// reloads notifications must import these — keeps the
// popover, bell sheet, and full-page filter chips from
// drifting when a prop is renamed.

// All notification props on the /v2/notifications page.
export const V2_NOTIFICATIONS_PROPS = [
  "filter",
  "counts",
  "notifications",
  "popover_notifications",
  "nav_counts",
] as const

// Just the popover/sheet payload — used by the sidebar
// bell and the mobile bell button to refresh their tiny
// curated list without re-rendering the full page.
export const V2_NOTIFICATIONS_POPOVER_PROPS = [
  "popover_notifications",
  "nav_counts",
] as const
